const bistroAdminUrl = (import.meta.env.VITE_BISTRO_ADMIN_URL || 'http://localhost:3000').replace(/\/$/, '');
const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000').replace(/\/$/, '');
const payrollOrigin = (import.meta.env.VITE_PAYROLL_APP_ORIGIN || window.location.origin).replace(/\/$/, '');

export default {
  bistroAdminUrl,
  apiBaseUrl,
  payrollOrigin,
  /** Phase 2: shared cookie name on .rebelity.com */
  authCookieName: 'rebelity_auth',
};
